import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';
import Link from '../Link/Link';
import Button from '../Link/Button';
import Picture from './Picture';

import './Tile.module.css';

const tileTypes = [
  { name: 'none', value: 'plain' },
  { name: 'link_list', value: 'gray-border' },
  { name: 'link_list_gray', value: 'gray' },
  { name: 'basic', value: 'basic-tile' },
  { name: 'square_background', value: 'square' }
];

const Tile = ({
  title,
  ctaText,
  image,
  imageAlt,
  themeColor,
  url,
  tileStyle,
  lastChild
}) => {
  const tileType = tileTypes.find(tile => tile.name === tileStyle).value;

  if (!image) {
    return null;
  }
  return (
    <Link to={url} styleName="link-list-link">
      <div
        style={{
          backgroundImage:
            tileStyle === 'square_background' ? `url(${image})` : 'none'
        }}
        styleName={classNames('tile', 'link_list', tileType, {
          last: lastChild
        })}
      >
        {tileStyle !== 'square_background' && (
          <Picture largeImage={image} width="100%" alt={imageAlt} />
        )}
        {tileStyle === 'basic' ? (
          <p>
            <Button to={url} arrow="right-caret" color="inherit-color">
              {ctaText}
            </Button>
          </p>
        ) : (
          <>
            <p styleName="link-title">{title}</p>
            <p styleName="link-button">{ctaText}</p>
          </>
        )}
      </div>
    </Link>
  );
};

Tile.propTypes = {
  title: PropTypes.string,
  ctaText: PropTypes.string,
  themeColor: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  id: PropTypes.number,
  imageHeight: PropTypes.node,
  imageWidth: PropTypes.node,
  tileStyle: PropTypes.string,
  lastChild: PropTypes.bool,
  gradientOverlay: PropTypes.bool,
  classes: PropTypes.any
};

export default DisplayComponent(Tile);
